import { render, staticRenderFns } from "./SithMesStoolOpenPrList.vue?vue&type=template&id=70929afc&scoped=true&"
import script from "./SithMesStoolOpenPrList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolOpenPrList.vue?vue&type=script&lang=js&"
import style0 from "./SithMesStoolOpenPrList.vue?vue&type=style&index=0&id=70929afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70929afc",
  null
  
)

export default component.exports